import { create } from "zustand";

import type { TMessageResponse } from "@services/webSocket";

export type TChatStore = {
	messageList: TMessageResponse[];
	setMessageList: (message: TMessageResponse) => void;
	clearMessageList: () => void;
	deleteAllUserMessages: (userId: string) => void;
	isNewSystemMessage: boolean;
	setIsNewSystemMessage: (value: boolean) => void;
	resetState: () => void;
};

export const useChatStore = create<TChatStore>()((set, _, store) => ({
	messageList: [],
	setMessageList: (message: TMessageResponse) => set((state) => ({ messageList: [...state.messageList, message] })),
	clearMessageList: () => set({ messageList: [] }),
	deleteAllUserMessages: (userId: string) =>
		set((state) => {
			const filteredMessages = state.messageList.filter((msg) => msg.fromUserId !== userId);

			return { messageList: filteredMessages };
		}),
	isNewSystemMessage: false,
	setIsNewSystemMessage: (value: boolean) => set({ isNewSystemMessage: value }),
	resetState: () => {
		set(store.getInitialState(), true);
	},
}));
